class AlertCountController {
  constructor(alertCountService) {
    this.alertCountService = alertCountService
  }

  get currentCount() {
    return this.alertCountService.currentCount
  }

}

AlertCountController.$inject = ['AlertCountService']

export default AlertCountController
